export default {
    intro: ({ values }: { values: { isAuto: boolean; questionTime: number; answerTime: number } }) => {
        const { isAuto, questionTime, answerTime } = values;
        if (isAuto) {
            return `ดูคำถามภายใน ${answerTime} วินาที แล้วเลือกจริงหรือเท็จภายใน ${questionTime} วินาที!`;
        } else {
            return 'ดูคำถามแล้วเลือก O/X กันเลย!';
        }
    },
    options: {
        auto: 'ดำเนินการอัตโนมัติ',
        manual: 'ดำเนินการด้วยตนเอง',
        timer: 'ตั้งค่าตัวจับเวลา',
        answerTime: 'เวลาดูคำถาม',
        questionTime: 'เวลาเลือกคำตอบ',
        answerCheckTime: 'เวลาดูเฉลย',
        showOtherAvatar: 'แสดงอวตารทั้งหมด',
        showOtherAvatarDescription: 'เลือกว่าจะแสดงอวตารของนักเรียนคนอื่นบนหน้าจอนักเรียนขณะเลือก OX หรือไม่',
    },
    topbar: {
        check: 'กรุณาดูคำถาม',
        question: 'กรุณาเลือกคำตอบ',
        result: 'เฉลยคำตอบ!',
        default: 'OX ควิซแสนสนุก',
    },
    buttons: {
        standby: 'เปิดคำถาม',
        question: 'ปิดการเลือกและเฉลยคำตอบ',
        check: 'เริ่มเลือก',
        unclickUser: {
            unselect: 'ดูคนที่<br />ยังไม่เลือก',
            allSelect: 'เลือกกันครบ<br />ทุกคนแล้ว!',
            count: '{count} คน',
        },
        next: 'คำถามถัดไป',
    },
    modal: {
        unselect: 'นักเรียนที่ยังไม่เลือก',
        timerError: 'หากต้องการเริ่ม OX ควิซในโหมดอัตโนมัติ<br>กรุณาตั้งค่าตัวจับเวลาทั้ง 3 ตัวให้ครบ',
    },
    toast: {
        unselect: 'ก่อนเลือกคำตอบ ลองดูคำถามก่อนนะ!',
    },
    standbyStep: ({ values }: { values: { index: number } }) => {
        const { index } = values;
        const messages = [
            'กำลังเติมลม<br />เข้าลูกโป่ง...',
            'กำลังอุ่น<br />บอลลูน...',
            'กำลังตรวจสอบ<br />ความปลอดภัย...',
        ];

        return messages[index];
    },
    resultStep: {
        result: 'คำตอบที่ถูกคือ <i></i>',
        nextQuestion: 'อีก {time} วินาที จะเริ่มคำถามถัดไป!',
    },
    autoMode: 'กำลังดำเนินการในโหมดอัตโนมัติ',
    questionAccuracy: {
        content: ({ values }: { values: { questionText: string; correctChoice: boolean } }) => {
            const { questionText, correctChoice } = values;
            return `${questionText} <strong>${correctChoice ? '(O: จริง)' : '(X: เท็จ)'}</strong>`;
        },
    },
    correctChoice: {
        true: 'จริง',
        false: 'เท็จ',
    },
    question: 'คำถาม',
    answer: 'คำตอบที่ถูก',
    explanation: 'คำอธิบาย',
    additionalMaterial: 'สื่อเพิ่มเติม',
    explanationMaterial: 'สื่อคำอธิบาย',
    table: {
        question: 'คำถาม',
        answerRate: 'อัตราการตอบถูก',
    },
    isAnswer: 'คำตอบคือ?',
    roundNumber: 'ข้อที่ {number}',
    timer: {
        remaining: '{count} วินาที',
    },
};
